export default __webpack_public_path__ + "static/media/skill development-04.68b37dad.png";